function productSelectDirective() {
	return {
		scope : {
			product : '=?',
			required:'@?',
			disabled:'&?',
			onSelectProduct: '&?',
			onRemoveProduct: '&?'
		},
		restrict : 'E',
		replace : true,
		templateUrl : function(elem, attr) {
			return 'views/directives/productSelectDirective.html';
		},
		controller : [ '$scope', '$window', 'alertService', 'productService', function($scope, $window, alertService, productService) {
			$scope.valueWasChangedFromSelector = false;
			$scope.availableProducts = [];
			$scope.isRequired = false;
			$scope.isDisabled = false;
			
			if($scope.required)
				$scope.isRequired = true;

			if($scope.disabled())
				$scope.isDisabled = true;

			$scope.searchProduct = function(query) {
				if($scope.productsCount && $scope.productsLimit){
					if($scope.productsCount <= $scope.productsLimit)
						return;
				}
				
				var filter = {};
				
				if(query){
					filter.name = query;
				}
				
				productService.searchProductsBasicInfo(filter).then(function(response) {
					var resp = response.getData();
					$scope.availableProducts = resp.results;
					if(!$scope.productsCount)
						$scope.productsCount = resp.totalRegisters;
					$scope.productsLimit = resp.limit;
                }, function(response) {
                	//on error
                });
			};
			
			$scope.onChange=function(product){
				if($scope.onSelectProduct != undefined){
					$scope.onSelectProduct({product:product});
				}
			}
            
		} ],
		link : function(scope, elem, attr) {
			if (angular.isUndefined(scope.required))
				scope.required = false;
			scope.$watch('product', function(newValue, oldValue) {
				if(!newValue.selected && !oldValue.selected)
					return;
				if(newValue.selected.length === 0 && oldValue.selected.length > 0){
					if(scope.onRemoveProduct != undefined){
						scope.onRemoveProduct({oldValue:oldValue.selected});
					}
				}
			}, true);
		}
	};
};

module.directive('productSelect', [ productSelectDirective ]);
